import {ReactElement} from "react";
import {renderToStaticMarkup} from "react-dom/server";
import slugify from "slugify";

import {formatDate} from "./dates";

const stripTagsFromString = (str: string): string => str.replace(/(<([^>]+)>)/gi, " ");
export const stringifyJSXElement = (element: ReactElement): string => {
    return stripTagsFromString(renderToStaticMarkup(element));
};
export const slugifyChartTitle = (title: ReactElement): string => {
    const stringifiedTitle = stringifyJSXElement(title);

    const slugifiedTitle = slugify(stringifiedTitle, {
        lower: true,
        strict: true,
        locale: "pl"
    });

    const date = formatDate(new Date(), "LLLL-yyyy");

    return `${slugifiedTitle}-${date}`;
};
